import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';

@Injectable({
  providedIn: 'root'
})
export class FilmApiService {
  private readonly filmVersionsEndpoint = 'film/film_versions';

  constructor(private httpApiService: HttpApiService) {
  }

  public filmVersions(cookies: string, idFilm: number): Observable<any> {
    return this.httpApiService.get<any>(this.filmVersionsEndpoint, {id_film: idFilm}, cookies);
  }
}
